import { Component, Input } from '@angular/core';
import { publicFile } from '@shared/helpers/public-file.helper';
import { Employee } from '@shared/models/employee.model';

interface DateComment {
  created: string;
  deleted: string;
  employee: Employee;
  endDate: string;
  id: number;
  modified: string;
  note: string;
  startDate: string;
  type: string;
}

@Component({
  selector: 'date-comment',
  templateUrl: './date-comment.component.html',
  styleUrls: ['./date-comment.component.scss']
})
export class DateCommentComponent {
  @Input() comment: DateComment;

  imageUrl(url: string): string {
    return publicFile(url, 100);
  }
}
